var _switch;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 24h-12c-3.3 0-6-2.7-6-6v-12c0-3.3 2.7-6 6-6h12c3.3 0 6 2.7 6 6v12c0 3.3-2.7 6-6 6z",
    fill: "#02bc7d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 11.4c-.4-.4-.9-.4-1.3 0s-.4.9 0 1.3l2.7 2.7c.2.2.4.3.6.3s.4-.1.6-.3l6.3-7.2c.3-.4.3-1-.2-1.3-.4-.3-.9-.3-1.2.1l-5.5 6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.1 11.1c-.5 0-.9.4-.9.9 0 3.9-3.2 7.2-7.2 7.2s-7.1-3.3-7.1-7.2c0-1.9.7-3.7 2.1-5 1.3-1.4 3.1-2.2 5.1-2.2.5 0 1.2.1 1.7.2.4.2 1-.1 1.2-.6s-.2-.9-.6-1.1h-.1c-.8-.2-1.5-.3-2.3-.3-4.9 0-9 4-9 9 0 2.3 1 4.7 2.6 6.3 1.7 1.7 3.9 2.6 6.3 2.6 4.9 0 9-4 9-9 .1-.4-.4-.8-.8-.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnSuccessIcon);
export default __webpack_public_path__ + "static/media/onSuccess_icon.1a29a59a6e8bef375481cf0785ee51cf.svg";
export { ForwardRef as ReactComponent };